export default __webpack_public_path__ + "static/media/pic11.91f15cf7.jpg";